import { render, staticRenderFns } from "./IpoDocsWaveSummary.vue?vue&type=template&id=60a9c0cb"
import script from "./IpoDocsWaveSummary.vue?vue&type=script&lang=js"
export * from "./IpoDocsWaveSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports